(function () {
  'use strict';

  var desktopMq = window.matchMedia('(min-width: 769px)');
  var lastAddToCartTrigger = null;
  var cartBanner = null;
  var cartBannerOpen = false;
  var returnFocusTarget = null;

  function getFocusable(container) {
    if (!container) return [];
    return Array.prototype.slice.call(container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (el) {
      return !el.hasAttribute('hidden') && el.getAttribute('aria-hidden') !== 'true' && !el.closest('[inert]');
    });
  }

  /* ------------------------------------------------------------------
   * 1. Desktop mega-menu keyboard behavior
   * ------------------------------------------------------------------ */
  function initMegaMenus() {
    var items = document.querySelectorAll('.header__menu-item--hasMega');

    Array.prototype.forEach.call(items, function (item, index) {
      var trigger = item.querySelector(':scope > .header__menu-item-link');
      var mega = item.querySelector(':scope > .header__mega');
      if (!trigger || !mega) return;

      var megaId = mega.id || ('yn-mega-menu-' + index);
      mega.id = megaId;
      trigger.setAttribute('data-yn-mega-trigger', '');

      function syncMegaForViewport() {
        if (desktopMq.matches) {
          /* Desktop: keep the mega menu closed to keyboard focus until the
             user intentionally opens it with Space/ArrowDown. */
          trigger.setAttribute('aria-haspopup', 'true');
          trigger.setAttribute('aria-expanded', 'false');
          trigger.setAttribute('aria-controls', megaId);
          mega.setAttribute('aria-hidden', 'true');
          mega.setAttribute('inert', '');
          item.classList.remove('yn-a11y-open');
        } else {
          /* Mobile: the hamburger navigation lays the mega menu content out
             inline. It must NOT be inert/aria-hidden or the accordion links
             and featured Shop Now cards cannot be tapped or reached. */
          item.classList.remove('yn-a11y-open');
          trigger.removeAttribute('aria-haspopup');
          trigger.removeAttribute('aria-expanded');
          trigger.removeAttribute('aria-controls');
          mega.setAttribute('aria-hidden', 'false');
          mega.removeAttribute('inert');
        }
      }

      syncMegaForViewport();
      if (typeof desktopMq.addEventListener === 'function') {
        desktopMq.addEventListener('change', syncMegaForViewport);
      } else if (typeof desktopMq.addListener === 'function') {
        desktopMq.addListener(syncMegaForViewport);
      }

      function openMenu(options) {
        if (!desktopMq.matches) return;
        var moveFocus = options && options.moveFocus;

        closeOtherMegaMenus(item);
        item.classList.add('yn-a11y-open');
        trigger.setAttribute('aria-expanded', 'true');
        mega.setAttribute('aria-hidden', 'false');
        mega.removeAttribute('inert');

        if (moveFocus) {
          var first = getFocusable(mega)[0];
          if (first) first.focus();
        }
      }

      function closeMenu(options) {
        var restoreFocus = options && options.restoreFocus;
        item.classList.remove('yn-a11y-open');
        trigger.setAttribute('aria-expanded', 'false');
        mega.setAttribute('aria-hidden', 'true');
        mega.setAttribute('inert', '');
        if (restoreFocus) trigger.focus();
      }

      item._ynA11yCloseMega = closeMenu;

      trigger.addEventListener('keydown', function (event) {
        if (!desktopMq.matches) return;

        if (event.key === ' ' || event.key === 'ArrowDown') {
          event.preventDefault();
          openMenu({ moveFocus: true });
        } else if (event.key === 'Escape') {
          event.preventDefault();
          closeMenu({ restoreFocus: true });
        }
        /* Enter intentionally keeps the anchor's normal navigation behavior. */
      });

      mega.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeMenu({ restoreFocus: true });
        }
      });

      /* Keep the existing hover experience usable: inert must be removed while hovered. */
      item.addEventListener('mouseenter', function () {
        if (!desktopMq.matches) return;
        trigger.setAttribute('aria-expanded', 'true');
        mega.setAttribute('aria-hidden', 'false');
        mega.removeAttribute('inert');
      });

      item.addEventListener('mouseleave', function () {
        if (!desktopMq.matches) return;
        if (!item.classList.contains('yn-a11y-open')) {
          trigger.setAttribute('aria-expanded', 'false');
          mega.setAttribute('aria-hidden', 'true');
          mega.setAttribute('inert', '');
        }
      });

      /* If focus leaves an intentionally opened menu, close it without stealing focus. */
      item.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (!item.contains(document.activeElement) && item.classList.contains('yn-a11y-open')) {
            closeMenu({ restoreFocus: false });
          }
        }, 0);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeOtherMegaMenus(null, true);
    });
  }

  function closeOtherMegaMenus(exceptItem, restoreFocus) {
    var openItems = document.querySelectorAll('.header__menu-item--hasMega.yn-a11y-open');
    Array.prototype.forEach.call(openItems, function (item) {
      if (item !== exceptItem && typeof item._ynA11yCloseMega === 'function') {
        item._ynA11yCloseMega({ restoreFocus: !!restoreFocus });
      }
    });
  }

  /* ------------------------------------------------------------------
   * 2. Cart banner dialog focus management + live announcement
   * ------------------------------------------------------------------ */
  function initCartBanner() {
    cartBanner = document.querySelector('[cart-banner]');
    if (!cartBanner) return;

    var closeButton = cartBanner.querySelector('.cartBanner__close');
    var liveRegion = document.getElementById('yn-cart-status');

    cartBanner.setAttribute('aria-hidden', 'true');
    cartBanner.setAttribute('inert', '');

    /* Remember the control that initiated an add-to-cart action. */
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[add-to-cart]');
      if (trigger) lastAddToCartTrigger = trigger;
    }, true);

    window.addEventListener('pact:cart:add', function (event) {
      var detail = event.detail || {};
      var productName = detail.product_title || detail.title || 'Item';
      var qty = detail.quantity || 1;

      returnFocusTarget = lastAddToCartTrigger && document.contains(lastAddToCartTrigger)
        ? lastAddToCartTrigger
        : document.activeElement;

      if (liveRegion) {
        /* Clear first so repeated additions of the same item are announced. */
        liveRegion.textContent = '';
        window.setTimeout(function () {
          liveRegion.textContent = qty + ' ' + (qty === 1 ? 'item' : 'items') + ' added to your Shopping Bag: ' + productName + '.';
        }, 50);
      }

      /* Let the theme's existing CartBanner handler render/open first. */
      window.setTimeout(function () {
        openAccessibleCartBanner();
        updateCartLinkNames();
      }, 80);
    });

    if (closeButton) {
      closeButton.addEventListener('click', function () {
        /* Theme close handler runs too; restore after it begins closing. */
        window.setTimeout(closeAccessibleCartBanner, 0);
      });
    }

    cartBanner.addEventListener('keydown', trapCartBannerFocus);

    /* Detect the theme's automatic 20-second close and restore focus. */
    var observer = new MutationObserver(function () {
      var visuallyOpen = cartBanner.classList.contains('cartBanner--ready');
      if (cartBannerOpen && !visuallyOpen) closeAccessibleCartBanner();
    });
    observer.observe(cartBanner, { attributes: true, attributeFilter: ['class'] });
  }

  function openAccessibleCartBanner() {
    if (!cartBanner) return;
    cartBannerOpen = true;
    cartBanner.removeAttribute('inert');
    cartBanner.setAttribute('aria-hidden', 'false');

    /* Focus the dialog container so its accessible name is announced first. */
    cartBanner.focus({ preventScroll: true });
  }

  function closeAccessibleCartBanner() {
    if (!cartBanner || !cartBannerOpen) return;
    cartBannerOpen = false;
    cartBanner.setAttribute('aria-hidden', 'true');
    cartBanner.setAttribute('inert', '');

    if (returnFocusTarget && document.contains(returnFocusTarget) && typeof returnFocusTarget.focus === 'function') {
      returnFocusTarget.focus({ preventScroll: true });
    }
    returnFocusTarget = null;
  }

  function trapCartBannerFocus(event) {
    if (!cartBannerOpen || !cartBanner) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      var closeButton = cartBanner.querySelector('.cartBanner__close');
      if (closeButton) closeButton.click();
      return;
    }

    if (event.key !== 'Tab') return;

    var focusable = getFocusable(cartBanner);
    if (!focusable.length) {
      event.preventDefault();
      cartBanner.focus();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    } else if (document.activeElement === cartBanner && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  }

  /* ------------------------------------------------------------------
   * 3. Shopping Bag accessible names
   * ------------------------------------------------------------------ */
  function updateCartLinkNames() {
    var cartLinks = document.querySelectorAll('a.header__btn-cart');
    Array.prototype.forEach.call(cartLinks, function (link) {
      link.setAttribute('aria-label', 'Shopping Bag');
    });
  }


  /* ------------------------------------------------------------------
   * 4. Mobile navigation button accessible name/state
   * ------------------------------------------------------------------ */
  function initMobileNavigationButton() {
    var button = document.querySelector('.header__burger');
    if (!button) return;

    function sync() {
      var open = button.classList.contains('header__burger--open') || document.documentElement.classList.contains('mobileMenu--opened');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      button.setAttribute('aria-label', open ? 'Close navigation menu' : 'Open navigation menu');
    }

    sync();
    var observer = new MutationObserver(sync);
    observer.observe(button, { attributes: true, attributeFilter: ['class'] });
  }

  /* ------------------------------------------------------------------
   * 5. Accordion relationships and expanded state
   * The compiled theme JS toggles the wrapper. Mirror that state on the
   * controlling button, where assistive technology expects it.
   * ------------------------------------------------------------------ */
  function initAccordions() {
    var accordions = document.querySelectorAll('[accordion]');
    Array.prototype.forEach.call(accordions, function (accordion, index) {
      var trigger = accordion.querySelector('[accordion-trigger]');
      var content = accordion.querySelector('.accordion__content');
      if (!trigger || !content) return;

      var contentId = content.id || ('yn-accordion-content-' + index);
      content.id = contentId;
      trigger.setAttribute('aria-controls', contentId);

      function sync() {
        var open = accordion.classList.contains('accordion--open');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        content.setAttribute('aria-hidden', open ? 'false' : 'true');
        /* Remove the legacy state from the generic wrapper if theme JS adds it. */
        if (accordion.hasAttribute('aria-expanded')) accordion.removeAttribute('aria-expanded');
      }

      sync();
      var observer = new MutationObserver(sync);
      observer.observe(accordion, { attributes: true, attributeFilter: ['class', 'aria-expanded'] });
    });
  }

  /* ------------------------------------------------------------------
   * 6. Skip link focus reliability
   * ------------------------------------------------------------------ */
  function initSkipLink() {
    var skip = document.querySelector('.yn-skip-link');
    var main = document.getElementById('main');
    if (!skip || !main) return;

    skip.addEventListener('click', function () {
      window.setTimeout(function () {
        main.focus({ preventScroll: true });
      }, 0);
    });
  }



  /* ------------------------------------------------------------------
   * 7. Search panel accessibility / VoiceOver
   * The original theme keeps aria-hidden="true" on the search panel even
   * while its textarea receives focus. That removes the search field from
   * the accessibility tree and can cause VoiceOver to announce only
   * "group". Keep aria-hidden in sync with the panel's open/closed state.
   * ------------------------------------------------------------------ */
  function initSearchAccessibility() {
    var panel = document.querySelector('[search-form][dropdown-id="search"]');
    if (!panel) return;

    var input = panel.querySelector('.searchForm__input');
    if (input) {
      input.setAttribute('aria-label', 'Search Young Nails');
      input.setAttribute('role', 'searchbox');
    }

    function sync() {
      /* The theme removes --idle as soon as opening begins, well before it
         moves focus to the textarea. It adds --idle again after closing. */
      var exposed = !panel.classList.contains('dropdownForm__item--idle');
      panel.setAttribute('aria-hidden', exposed ? 'false' : 'true');
    }

    sync();
    var observer = new MutationObserver(sync);
    observer.observe(panel, { attributes: true, attributeFilter: ['class'] });
  }



  /* ------------------------------------------------------------------
   * 8. Klaviyo form success announcements
   * Keep the theme's existing visual success behavior intact and mirror
   * the revealed confirmation text into a persistent live region so
   * VoiceOver and other screen readers announce the result reliably.
   * ------------------------------------------------------------------ */
  function initFormStatusAnnouncements() {
    var forms = document.querySelectorAll('.klaviyo-form');

    Array.prototype.forEach.call(forms, function (form) {
      var success = form.querySelector('.form__success');
      var status = form.querySelector('[data-yn-form-status]');
      if (!success || !status) return;

      var lastMessage = '';

      function announceIfVisible() {
        if (success.getAttribute('aria-hidden') !== 'false') return;

        var message = (success.textContent || '').replace(/\s+/g, ' ').trim();
        if (!message) return;

        /* Clear first so the same confirmation can be announced again
           if the form is submitted more than once in the same session. */
        status.textContent = '';
        window.setTimeout(function () {
          status.textContent = message;
          lastMessage = message;
        }, 50);
      }

      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i += 1) {
          if (mutations[i].type === 'attributes' && mutations[i].attributeName === 'aria-hidden') {
            announceIfVisible();
            break;
          }
        }
      });

      observer.observe(success, { attributes: true, attributeFilter: ['aria-hidden'] });
    });
  }



  /* ------------------------------------------------------------------
   * 9. Home banner carousel pagination accessibility
   * Turn Swiper's visual pagination dots into keyboard-operable controls.
   * Each dot is named from its banner title so VoiceOver users know which
   * banner they are choosing before they activate it.
   * ------------------------------------------------------------------ */
  function initHomeBannerCarouselAccessibility() {
    var carousels = document.querySelectorAll('.homeBannerCarousel');

    Array.prototype.forEach.call(carousels, function (carousel) {
      var pagination = carousel.querySelector('.swiper-pagination');
      var swiperContainer = carousel.querySelector('.homeBannerCarousel__images.swiper-container');
      if (!pagination || !swiperContainer) return;

      carousel.setAttribute('role', 'region');
      carousel.setAttribute('aria-roledescription', 'carousel');
      carousel.setAttribute('aria-label', 'Featured promotions');
      pagination.setAttribute('role', 'group');
      pagination.setAttribute('aria-label', 'Choose a featured promotion');

      function getRealSlides() {
        var slides = carousel.querySelectorAll('.homeBannerCarousel__slide:not(.swiper-slide-duplicate)');
        return Array.prototype.slice.call(slides);
      }

      function getSlideTitle(slide, index) {
        if (!slide) return 'Banner ' + (index + 1);
        var heading = slide.querySelector('.homeBannerCarousel__title');
        var title = heading ? (heading.textContent || '').replace(/\s+/g, ' ').trim() : '';
        return title || ('Banner ' + (index + 1));
      }

      function updateSlideTabOrder() {
        var allSlides = carousel.querySelectorAll('.homeBannerCarousel__slide');
        Array.prototype.forEach.call(allSlides, function (slide) {
          var active = slide.classList.contains('swiper-slide-active');
          var links = slide.querySelectorAll('a, button, input, select, textarea, [tabindex]');
          Array.prototype.forEach.call(links, function (control) {
            if (active) {
              if (control.hasAttribute('data-yn-carousel-tabindex')) {
                var oldValue = control.getAttribute('data-yn-carousel-tabindex');
                if (oldValue === '') control.removeAttribute('tabindex');
                else control.setAttribute('tabindex', oldValue);
                control.removeAttribute('data-yn-carousel-tabindex');
              }
            } else {
              if (!control.hasAttribute('data-yn-carousel-tabindex')) {
                control.setAttribute('data-yn-carousel-tabindex', control.getAttribute('tabindex') || '');
              }
              control.setAttribute('tabindex', '-1');
            }
          });
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
      }

      function enhanceBullets() {
        var bullets = pagination.querySelectorAll('.swiper-pagination-bullet');
        if (!bullets.length) return;

        var realSlides = getRealSlides();
        Array.prototype.forEach.call(bullets, function (bullet, index) {
          var title = getSlideTitle(realSlides[index], index);
          var selected = bullet.classList.contains('swiper-pagination-bullet-active');

          bullet.setAttribute('role', 'button');
          bullet.setAttribute('tabindex', '0');
          bullet.setAttribute('aria-label', title + ', slide ' + (index + 1) + ' of ' + bullets.length);
          bullet.setAttribute('aria-current', selected ? 'true' : 'false');

          if (!bullet.hasAttribute('data-yn-keyboard-ready')) {
            bullet.setAttribute('data-yn-keyboard-ready', 'true');
            bullet.addEventListener('keydown', function (event) {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                bullet.click();
              }
            });
          }
        });

        updateSlideTabOrder();
      }

      /* Swiper creates the bullets after the page markup has loaded, so
         enhance once immediately and again whenever pagination/slide state
         changes. */
      enhanceBullets();
      window.setTimeout(enhanceBullets, 250);
      window.setTimeout(enhanceBullets, 1000);

      var observer = new MutationObserver(function () {
        enhanceBullets();
      });
      observer.observe(carousel, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class']
      });
    });
  }

  function init() {
    updateCartLinkNames();
    initMegaMenus();
    initCartBanner();
    initMobileNavigationButton();
    initAccordions();
    initSkipLink();
    initSearchAccessibility();
    initFormStatusAnnouncements();
    initHomeBannerCarouselAccessibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
